'use server'

import axios from 'axios'

const getPublicClient = () => {
    const baseURL = import.meta.env.VITE_API_BASE_URL

    return axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 30000,
    })
}

export interface PublicTeleconsultationRoom {
    id: number
    dailyRoomUrl: string
    patientDailyToken: string
    status: string
    scheduledAt: string
    startedAt?: string
    endedAt?: string
    maxDuration: number
    enableChat: boolean
    enableScreenShare?: boolean
    recordingEnabled: boolean
    title?: string
    clientName?: string
    professional?: {
        id: number
        name: string
        specialties?: Array<{
            specialty: { id: number; name: string }
        }>
    }
    client?: {
        id: number
        name: string
    }
    company?: {
        id: number
        name: string
    }
}

export interface PublicApiResponse<T> {
    success: boolean
    result: T
    error?: string
}

export async function getPublicTeleconsultation(
    token: string
): Promise<PublicApiResponse<PublicTeleconsultationRoom>> {
    try {
        const client = getPublicClient()
        const response = await client.get(
            `/teleconsultations/public/${token}`
        )
        return { success: true, result: response.data }
    } catch (error: any) {
        return {
            success: false,
            result: {} as any,
            error:
                error?.response?.data?.message ||
                'Erro ao carregar teleconsulta',
        }
    }
}

export async function joinPublicTeleconsultation(
    token: string,
    name?: string
): Promise<PublicApiResponse<any>> {
    try {
        const client = getPublicClient()
        const response = await client.post(
            `/teleconsultations/public/${token}/join`,
            { name }
        )
        return { success: true, result: response.data }
    } catch (error: any) {
        return {
            success: false,
            result: {} as any,
            error:
                error?.response?.data?.message ||
                'Erro ao entrar na teleconsulta',
        }
    }
}

export async function getPublicChatMessages(
    token: string
): Promise<PublicApiResponse<any[]>> {
    try {
        const client = getPublicClient()
        const response = await client.get(
            `/teleconsultations/public/${token}/chat`
        )
        return { success: true, result: response.data }
    } catch (error: any) {
        return {
            success: false,
            result: [],
            error:
                error?.response?.data?.message ||
                'Erro ao carregar mensagens',
        }
    }
}

export async function sendPublicChatMessage(
    token: string,
    message: string
): Promise<PublicApiResponse<any>> {
    try {
        const client = getPublicClient()
        const response = await client.post(
            `/teleconsultations/public/${token}/chat`,
            { message }
        )
        return { success: true, result: response.data }
    } catch (error: any) {
        return {
            success: false,
            result: {} as any,
            error:
                error?.response?.data?.message ||
                'Erro ao enviar mensagem',
        }
    }
}
